import { ReactElement, ReactNode } from 'react';
import { StyledButton } from './styles';

export type ButtonProps = {
  id: string;
  type: 'button' | 'submit';
  children: ReactElement | ReactNode;
  color: string;
  sxwidth?: string;
  sxheight?: string;
  sxhover?: string | null;
  sxgap?: string;
  sxmargintop?: string;
  sxmarginleft?: string;
  $sxdisabled?: boolean;
  onClick?: () => void;
}

export function Button({
  id, type, children, color, onClick, sxwidth, sxheight, sxhover, sxgap,
  sxmargintop, sxmarginleft, $sxdisabled
}: ButtonProps) {
  return (
    <StyledButton
      id={id}
      type={type}
      color={color}
      onClick={onClick}
      sxwidth={sxwidth}
      sxheight={sxheight}
      sxhover={sxhover}
      sxgap={sxgap}
      sxmargintop={sxmargintop}
      sxmarginleft={sxmarginleft}
      $sxdisabled={$sxdisabled}
    >
      {children}
    </StyledButton>
  );
}
